export const get_unread_notifications_count = `query get_unread_notifications_count{
    get_unread_notifications_count
}`;
